/** The unit that counts whole things. The authoritative value is `MeasurementUnit::ITEMS` in `support/Measurement`. */
const ITEM_UNIT_IDENTIFIER = 'items' as const

export { ITEM_UNIT_IDENTIFIER }
